
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { WindowType } from '../../../util';
import GroupsForSurvey from '../group/GroupsForSurvey';
import TabSurveys from './Creator/TabSurveys';
import AdvanceRegistration from '../advanceRegistration/AdvanceRegistration';
import TabButton from '../../util/TabButton';
import AdvanceRegistrationConfig from '../advanceRegistration/AdvanceRegistrationConfig';
import TabCockpit from '../cockpit/TabCockpit';

declare var window: WindowType;

@Component({
  name: 'SurveyJSCreatorComponent',
  components: {
    AdvanceRegistration,
    AdvanceRegistrationConfig,
    GroupsForSurvey,
    TabButton,
    TabCockpit,
    TabSurveys,
  },
})
export default class SurveyJSCreatorComponent extends Vue {
  tab: 'survey' | 'groups' | 'advanceRegistration' | 'pinned' | 'advanceRegistrationConfig' | 'cockpit' = 'survey';

  mounted(): void {
    if (this.tab === 'survey' && !this.canSeeSurveys) {
      this.tab = 'groups';
    }
    if (this.tab === 'groups' && !this.canSeeGroups) {
      this.tab = 'advanceRegistration';
    }
  }

  get canSeeAdvanceRegistration(): boolean {
    return window.application.permissions.survey.group.advanceRegistration;
  }

  get canSeeAdvanceRegistrationApprovalGroups(): boolean {
    return window.application.permissions.visitorManagement.approvalGroups;
  }

  get canSeeCockpit(): boolean {
    return window.application.permissions.visitorManagement.cockpit;
  }

  get canSeeGroups(): boolean {
    return window.application.permissions.group.admin;
  }

  get canSeeSurveys(): boolean {
    return window.application.permissions.survey.admin || window.application.permissions.survey.approval;
  }
}
